export default __webpack_public_path__ + "static/swiggy-c6715148d5ee9986cf0ab041187bce63.svg";